// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_MarkPaidInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface SetupFee_MarkPaidInput {
franquia_id: number
reason?: string
}

registerContract('SetupFee_MarkPaidInput', {
  franquia_id: { type: 'number',  required: true },
  reason:      { type: 'string',  required: false },
})
